function equalizeSlideHeights() {
    var tallestSlide = 0;
    $('.testimonial-blocks-wrapper .slick-slide').each(function() {
      var slideHeight = $(this).height();
      if (slideHeight > tallestSlide) {
        tallestSlide = slideHeight;
      }
    });

    // $('.testimonial-blocks-wrapper .slick-slide').css('height', tallestSlide);
  }

$(document).ready(function () {

  $('.testimonial-blocks-wrapper').on('init', function(event, slick) {
    equalizeSlideHeights();
  });

  // Call on window resize
  var resizeTimer = null;
  $(window).on('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      equalizeSlideHeights();
    }, 250);
  });
  
  if($(window).width() < 750) {
    $('.footer-block--menu').wrapAll('<div class="footer-block--menu---wrapper"></div>')
  }
  
  $(document).on("change", '.color_option [type="radio"]', function () {
    window.location.href = $(this).attr("data-url");
  });

  $(document).on("click", ".verticle_slide__item", function () {
    var $el = $(this),
      $wrap = $el.closest("media-gallery"),
      target = $el.attr("data-target");
    $wrap.find(".verticle_slide__item").removeClass("active");
    $wrap.find(".product__media-item").removeClass("is-active");
    $el.addClass("active");
    $(`#Slide-${target}`).addClass("is-active");
  });

  $(".verticle__slider").slick({
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
  }).slick('slickGoTo', 1);
if($(window).width() <= 767){
  if($(".collections_product__slider").attr('data-mobile')== 'true'){
      $(".collections_product__slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
  }
}
  else{
  $(".collections_product__slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
  }
  $(document).on("click", ".fcs__tab_btn", function () {
    var $el = $(this),
      $wrap = $el.closest(".collections_tab__wrapper"),
      tgt_cls = $el.attr("data-target");
    $wrap.find(".fcs__tab_btn").removeClass("active");
    $el.addClass("active");
    $wrap.find(".view_all_btn").hide();
    $(`#${tgt_cls}`).show();
    if($(".collections_product__slider").attr('data-mobile') == 'false' && $(window).width() <=767){
      $('.collections_product__slider .cps__item').hide();
      $('.'+tgt_cls).show();
    }
    try {
      $(".collections_product__slider").slick("slickUnfilter");
      $(".collections_product__slider").slick("slickFilter", `.${tgt_cls}`);
    } catch (error) {
      console.log(error);
    }
  });
if($(".collections_product__slider").attr('data-mobile') == 'false' && $(window).width() <=767){
  $('.fcs__tab_btn.active').click();
}
  setTimeout(function () {
    $(".collections_tab__wrapper").each(function () {
      $(this).find(".fcs__tab_btn").eq(0).trigger("click");
    });
  }, 600);

  $(document).on("click", ".tab_title", function () {
    var $el = $(this),
      $wrap = $el.closest(".tabs__wrapper"),
      $content = $wrap.find(".tab_content"),
      tgt_cls = $el.attr("target");
    $wrap.find(".tab_title").removeClass("active");
    $el.addClass("active");
    $content.hide();
    $(`#${tgt_cls}`).show();
  });

  $(".testimonial-blocks-wrapper").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".section.faq summary").eq(0).click();

  $(document).on("click", ".btn__paginate", function (e) {
    e.preventDefault();
    var $el = $(this),
      url = $el.attr("href");
    if ($el.hasClass("loader")) {
      return;
    }
    $el.addClass("loader");
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        var $htlm = $(html),
          $btn = $htlm.find("btn__paginate"),
          href = $btn.attr("href"),
          isnextdata = $btn.attr("is-nextdata");
        $("#product-grid").append($htlm.find("#product-grid").html());
        $el
          .closest(".pagination__btn_wrap")
          .html($htlm.find(".pagination__btn_wrap").html());
      });
  });
}); //ready

function related__slider() {
  console.log("call related__slider<<<");
  $(".related__slider").slick({
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
          dots: true,
        },
      },
    ],
  });
}
 $(document).on('shopify:section:load', function(event) {
      var $section = $(event.target);
      if($(window).width() <= 767){
  if($(".collections_product__slider").attr('data-mobile')== 'true'){
      $(".collections_product__slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
  }
}
  else{
  $(".collections_product__slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
  }
     $(".testimonial-blocks-wrapper").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

    });

$(document).ready(function() {
    var maxHeight = 0;

    // Find the maximum height of the .card__heading elements  
    $('.card__heading').each(function() {
        var thisHeight = $(this).outerHeight();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });

    // Set the maximum height to all .card__heading elements  
    $('.card__heading').css('height', maxHeight);

  $('.verticle_slide__item').eq(1).click();
  $('button.thumbnail').eq(1).click();
});